<template>
  <page-header-wrapper>
    <div slot="extra">
      <router-link v-action:add :to="{ path: '/books/authors/form' }">
        <a-button type="primary" icon="plus">创建作者</a-button>
      </router-link>
    </div>
    <a-card :bordered="false" class="ant-pro-components-tag-select">
      <a-form layout="inline">
        <standard-form-row block>
          <div class="ant-pro-page-header-search">
            <a-input-search
              size="large"
              style="width: 80%; max-width: 522px;"
              v-model="params.where.name"
              placeholder="请输入名称"
              enter-button
              @search="getLists()"
            />
          </div>
        </standard-form-row>
      </a-form>
    </a-card>

    <div class="ant-pro-pages-list-projects-cardList">
      <div slot="operate" class="change-state">
        <a-radio-group @change="searchChangeState">
          <a-radio-button value="0">全部</a-radio-button>
          <a-radio-button value="1">展示</a-radio-button>
          <a-radio-button value="2">隐藏</a-radio-button>
        </a-radio-group>
      </div>
      <a-list
        :loading="loading"
        :data-source="list"
        :grid="{ gutter: 24, xl: 4, lg: 3, md: 3, sm: 2, xs: 1 }"
        :pagination="pagination"
      >
        <a-list-item slot="renderItem" slot-scope="item">
          <a-card class="ant-pro-pages-list-projects-card" hoverable>
            <viewer slot="cover" class="cover-pic">
              <img :src="globalUrl + item.logo" :key="item.name" />
            </viewer>
            <a-card-meta :title="item.name">
              <template slot="description">
                <ellipsis :length="50" style="margin-bottom: 1rem">{{ item.desc }}</ellipsis>
              </template>
            </a-card-meta>
            <div class="cardItemContent">
              <p>
                <a-tag v-for="(lable, key) in (item.keywords || '').split(',')" :key="key">
                  {{ lable }}
                </a-tag>
              </p>
              <span>末次修改：{{ moment(item.updated_at).fromNow() }}</span>
            </div>
            <template slot="actions">
              <a-tooltip title="编辑" v-action:update>
                <router-link v-action:update :to="'/books/authors/form/' + item.id">
                  <a-icon type="edit" />
                </router-link>
              </a-tooltip>

              <a-tooltip title="删除" v-action:delete>
                <a-popconfirm
                  title="确定要删除该作者吗？"
                  ok-text="确定"
                  cancel-text="取消"
                  @confirm="handleOnDelete(item.id)"
                >
                  <a-icon type="delete" />
                </a-popconfirm>
              </a-tooltip>
              <a-tooltip title="修改状态" v-action:state>
                <a-switch :checked="item.state === 1" @change="handleChangeState(item.id)">
                  <a-icon slot="checkedChildren" type="check" />
                  <a-icon slot="unCheckedChildren" type="close" />
                </a-switch>
              </a-tooltip>
            </template>
          </a-card>
        </a-list-item>
      </a-list>
    </div>
  </page-header-wrapper>
</template>

<script>
import { list, card, select } from '@/mixins' // 引入
import { TagSelect, StandardFormRow, Ellipsis, AvatarList } from '@/components'
const AvatarListItem = AvatarList.AvatarItem
const apiList = {
    changeState: '/partners/',
    getList: '/partners',
    typeList: '/partners/type',
    delete: '/partners/'
}
export default {
    name: 'BookAuthorList',
    mixins: [list, card, select], // 使用mixins
    components: {
        AvatarList,
        AvatarListItem,
        Ellipsis,
        TagSelect,
        StandardFormRow
    },
    data () {
        return {
            params: {
                where: {
                    identity: [4]
                }
            },
            apiList,
            typeList: [],
            typeLoad: false
        }
    },
    mounted () {
        this.getSelectLists({
            url: apiList.typeList,
            type: 'typeList',
            load: 'typeLoad'
        })
        this.getLists() // 获取广告位列表
    },
    methods: {

    }
}
</script>
